import { Button, Container, Title } from '@/components'
import styles from './styles.module.scss'
import Image from 'next/image'

import PriceImage from '/public/images/new-price.webp'
import foguetePlayUrl from '/public/images/foguete-play-logo.webp'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'

const Price = () => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  return (
    <section className={`fgt-section ${styles.price}`}>
      <Container classname={styles.price__container}>
        <Image
          className={styles['price__image']}
          src={foguetePlayUrl}
          width={209}
          height={93}
          alt="Foguete Play + ao vivo"
        />
        <Title Tag="h2" alignText="center" colorText={'light'}>
          Comece agora e <span>EXPERIMENTE POR 7 DIAS</span>
        </Title>
        <p className="fgt-subtitle fgt-subtitle--light">
          Acesse <strong>TREINOS AO VIVO</strong> e gravados. Invista na sua
          saúde com planos a partir de:
        </p>
        <div className={styles.price__content}>
          <Image
            className={styles['price__content--image']}
            src={PriceImage}
            width={258}
            height={144}
            alt="Foguete Play + ao vivo a partir de R$ 49,99"
          />
          <p className={styles['price__content--disclaimer']}>
            Você pode cancelar até o 7º dia.
          </p>
        </div>

        <div className="fgt-section__action">
          <Button
            id="btn-section-price"
            variant="primary"
            className="fgt-section__action--button"
            onClick={() => {
              onClickItem('comparePlans', 0)
            }}
          >
            QUERO GARANTIR MINHA OFERTA
          </Button>
        </div>
      </Container>
    </section>
  )
}

export default Price
